module.exports = __webpack_public_path__ + "static/assets/3d97c0d2dd797f00c614c9c7bdde2850.png";